<template>
  <div class="container-fluid p-0">
    <div class="row no-gutters">
      <div class="col-sm-12 text-center">
        <div
            :class="'404'"
            class="iq-error"
        >
          <img
              :src="image404"
              alt="404"
              class="img-fluid iq-error-img"
          />
          <h2 class="mb-0">{{ $t("public.errors.404.title") }}.</h2>
          <p>{{ $t("public.errors.general.text") }}.</p>
          <button
              class="btn btn-primary mt-3"
              @click="$router.go(-1)"
          >
            <i class="ri-home-4-line"></i>{{ $t("public.errors.404.mainLink") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {xray} from "../../config/pluginInit";

export default {
  name: "ErrorGenericPage",
  mounted() {
    xray.index();
    localStorage.removeItem("authorization");
  },
  data() {
    return {
      image404: require("../../assets/images/error/error-01.png"),
    };
  },
};
</script>